// const SkeletonLine = ({ height, width }) => (
//   <div
//     className="bg-gray-200 animate-pulse"
//     style={{ height: height, width: width }}
//   ></div>
// );

const SkeletonTable = () => {
  // const skeletonRowCount = 15; // Adjust this based on the number of skeleton rows you want

  return (
    <div className="flex justify-center items-center animate__animated animate__fadeIn h-[50vh]">
      {/* <table className="w-full border-collapse border border-b-0 border-l-0 border-r-0  mt-4 mx-3 print:mx-0">
        <colgroup>
          <col style={{ width: '60%' }} />
          <col style={{ width: '10%' }} />
          <col style={{ width: '10%' }} />
          <col style={{ width: '10%' }} />
        </colgroup>
        <thead>
          <tr>
            <td
              colSpan="4"
              className="border border-black py-1 text-sm"
              align="center"
            >
              <SkeletonLine height={20} width="20%" />
            </td>
          </tr>
          <tr>
            <td
              colSpan="4"
              className="border border-black py-1 text-sm"
              align="center"
            >
              <SkeletonLine height={20} width="20%" />
            </td>
          </tr>

          <tr>
            <th className="border border-black bg-gray-200 print:bg-gray-200 px-4 py-2">
              <SkeletonLine height={20} width="100%" />
            </th>
            <th className="border border-black bg-gray-200 print:bg-gray-200 px-4 py-2">
              <SkeletonLine height={20} width="100%" />
            </th>
            <th className="border border-black bg-gray-200 print:bg-gray-200 px-4 py-2">
              <SkeletonLine height={20} width="100%" />
            </th>
            <th className="border border-black bg-gray-200 print:bg-gray-200 px-4 py-2">
              <SkeletonLine height={20} width="100%" />
            </th>
          </tr>
        </thead>
        <tbody> */}
      {/* Skeleton rows */}
      {/* {Array.from({ length: skeletonRowCount }).map((_, index) => (
            <tr key={index}>
              <td className="px-2 py-0 border-l border-black">
                <SkeletonLine height={20} width="90%" />
              </td>
              <td className="px-2 py-0 border-l border-black">
                <SkeletonLine height={20} width="100%" />
              </td>
              <td className="px-2 py-0 border-l border-black">
                <SkeletonLine height={20} width="100%" />
              </td>
              <td className="px-2 py-0 border-x border-black">
                <SkeletonLine height={20} width="100%" />
              </td>
            </tr>
          ))}
        </tbody>
      </table> */}
      <p className="text-center text-3xl">Loading...</p>
    </div>
  );
};

export default SkeletonTable;
